import { useEffect, useReducer } from 'react';

/**
 * Re-renders the subscriber on every notification of a subscription:
 * `subscribe` registers a listener and returns its release. A subscriber
 * that has nothing to follow passes `undefined` and pays no re-render.
 */
export function useSubscriptionVersion(
    subscribe: ((listener: () => void) => () => void) | undefined
): void {
    const [, bump] = useReducer((version: number) => version + 1, 0);
    useEffect(() => subscribe?.(bump), [subscribe]);
}
